import clsx from 'clsx';
import logoMark from '@/assets/logo-mark.svg';

/**
 * Primary wordmark from the Figma UI kit (Brand Identity, node 1:34): the orange mark plus "1QA" in Audiowide.
 * Sizes are in em of the wordmark's font size so the Figma proportions hold at any size.
 * `inverted` is for always-dark surfaces (sidebar, auth panel): the `dark` class makes the tokens resolve dark.
 */
export function Logo({ className, withText = true, inverted }: { className?: string; withText?: boolean; inverted?: boolean }) {
  return (
    <span className={clsx('inline-flex items-center gap-[0.0595em] text-2xl', inverted && 'dark', className)}>
      <span className="px-[0.1285em] py-[0.1003em]">
        <img src={logoMark} alt={withText ? '' : '1QA'} className="block h-[0.9963em] w-auto" />
      </span>
      {withText && <span className="font-logo leading-none tracking-[-0.0238em] whitespace-nowrap text-fg">1QA</span>}
    </span>
  );
}
